"use client"

import { useState, useContext, useEffect } from "react"
import { ErpContext } from "../../context/ErpContext.js"
import {
  TextField,
  Button,
  Typography,
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  alpha,
  Alert,
  Fade,
  useTheme,
  InputAdornment,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material"
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline"
import PaymentIcon from "@mui/icons-material/Payment"
import CreditCardIcon from "@mui/icons-material/CreditCard"
import RefreshIcon from "@mui/icons-material/Refresh"
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"
import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"
import SaveIcon from "@mui/icons-material/Save"
import CloseIcon from "@mui/icons-material/Close"
import IconButton from "@mui/material/IconButton"
import Tooltip from "@mui/material/Tooltip"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import TablaMedioDePagoComponent from "./TablaMedioDePagoComponent.js"

const GestionMedioPago = () => {
  const theme = useTheme()
  const {
    postTipoMedioDePago,
    getTipoMedioDePago,
    tipoMedioDePago,
    postMedioDePago,
    updateTipoMedioDePago,
    deleteTipoMedioDePago,
    isNavbarCollapsed,
  } = useContext(ErpContext)

  // Estados para tipo medio de pago
  const [descripcionMedioPago, setDescripcionMedioPago] = useState("")
  const [verEnCajaMedioPago, setVerEnCajaMedioPago] = useState(false)
  const [verEnTransaccionMedioPago, setVerEnTransaccionMedioPago] = useState(false)
  const [esMultiMonedaMedioPago, setEsMultiMonedaMedioPago] = useState(false)
  const [esPagoDiferidoMedioPago, setEsPagoDiferidoMedioPago] = useState(false)
  const [userSelect, setUserSelect] = useState(false)
  const [afectaCuentaCorriente, setAfectaCuentaCorriente] = useState(false)

  // Estados para medio de pago
  const [selectedTipoMedioDePago, setSelectedTipoMedioDePago] = useState("")
  const [nuevoMedioDePago, setNuevoMedioDePago] = useState("")

  // Estados generales
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(null)
  const [successMessage, setSuccessMessage] = useState("")
  
  // Estados para modal de edición de tipos
  const [editTipoModalOpen, setEditTipoModalOpen] = useState(false)
  const [editingTipo, setEditingTipo] = useState(null)
  const [editTipoDescripcion, setEditTipoDescripcion] = useState("")
  const [editTipoVerEnCaja, setEditTipoVerEnCaja] = useState(false)
  const [editTipoVerEnTransaccion, setEditTipoVerEnTransaccion] = useState(false)
  const [editTipoEsMultiMoneda, setEditTipoEsMultiMoneda] = useState(false)
  const [editTipoEsPagoDiferido, setEditTipoEsPagoDiferido] = useState(false)
  const [editTipoUserSelect, setEditTipoUserSelect] = useState(false)
  const [editTipoAfectaCuentaCorriente, setEditTipoAfectaCuentaCorriente] = useState(false)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    setLoading(true)
    try {
      await getTipoMedioDePago()
    } catch (err) {
      console.error("Error al cargar datos:", err)
      setError("No se pudieron cargar los datos. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  const handleTipoMedioDePagoSubmit = async (e) => {
    e.preventDefault()
    if (!descripcionMedioPago.trim()) {
      setError("Por favor ingrese una descripción para el tipo de medio de pago")
      return
    }

    setLoading(true)
    try {
      await postTipoMedioDePago(
        descripcionMedioPago,
        verEnCajaMedioPago,
        verEnTransaccionMedioPago,
        esMultiMonedaMedioPago,
        esPagoDiferidoMedioPago,
        userSelect
      )
      // Limpiar formulario
      setDescripcionMedioPago("")
      setVerEnCajaMedioPago(false)
      setVerEnTransaccionMedioPago(false)
      setEsMultiMonedaMedioPago(false)
      setEsPagoDiferidoMedioPago(false)
      setUserSelect(false)
      setAfectaCuentaCorriente(false)
      
      setSuccessMessage("Tipo de medio de pago agregado correctamente")
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch (err) {
      console.error("Error al agregar tipo medio de pago:", err)
      setError("No se pudo agregar el tipo de medio de pago. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  const handleMedioDePagoSubmit = async (e) => {
    e.preventDefault()
    if (!selectedTipoMedioDePago || !nuevoMedioDePago.trim()) {
      setError("Por favor complete todos los campos para el medio de pago")
      return
    }

    setLoading(true)
    try {
      await postMedioDePago(selectedTipoMedioDePago, nuevoMedioDePago)
      setSelectedTipoMedioDePago("")
      setNuevoMedioDePago("")
      setSuccessMessage("Medio de pago agregado correctamente")
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch (err) {
      console.error("Error al agregar medio de pago:", err)
      setError("No se pudo agregar el medio de pago. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  const handleTipoEditStart = (tipo) => {
    setError(null)
    setEditingTipo(tipo)
    setEditTipoDescripcion(tipo.descripcion)
    setEditTipoVerEnCaja(tipo.verEnCaja)
    setEditTipoVerEnTransaccion(tipo.verEnTransaccion)
    setEditTipoEsMultiMoneda(tipo.esMultiMoneda)
    setEditTipoEsPagoDiferido(tipo.esPagoDiferido)
    setEditTipoUserSelect(tipo.userSelect)
    setEditTipoAfectaCuentaCorriente(tipo.afectaCuentaCorriente || false)
    setEditTipoModalOpen(true)
  }

  const handleTipoEditCancel = () => {
    setEditTipoModalOpen(false)
    setEditingTipo(null)
    setEditTipoDescripcion("")
    setEditTipoVerEnCaja(false)
    setEditTipoVerEnTransaccion(false)
    setEditTipoEsMultiMoneda(false)
    setEditTipoEsPagoDiferido(false)
    setEditTipoUserSelect(false)
    setEditTipoAfectaCuentaCorriente(false)
  }

  const handleTipoEditSave = async () => {
    if (!editTipoDescripcion.trim()) {
      setError("Por favor ingrese una descripción para el tipo")
      return
    }

    setLoading(true)
    try {
      await updateTipoMedioDePago(editingTipo.id, {
        descripcion: editTipoDescripcion.trim(),
        verEnCaja: editTipoVerEnCaja,
        verEnTransaccion: editTipoVerEnTransaccion,
        esMultiMoneda: editTipoEsMultiMoneda,
        esPagoDiferido: editTipoEsPagoDiferido,
        userSelect: editTipoUserSelect,
        afectaCuentaCorriente: editTipoAfectaCuentaCorriente,
      })
      setSuccessMessage("Tipo actualizado correctamente")
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
      handleTipoEditCancel()
    } catch (err) {
      console.error("Error al actualizar tipo:", err)
      setError("No se pudo actualizar el tipo. Intente nuevamente.")
    } finally {
      setLoading(false)
    }
  }

  const handleTipoDelete = async (tipoId) => {
    const confirmDelete = window.confirm("¿Está seguro de eliminar este tipo de medio de pago?")
    if (!confirmDelete) return

    setLoading(true)
    try {
      await deleteTipoMedioDePago(tipoId)
      setSuccessMessage("Tipo eliminado correctamente")
      setSuccess(true)
      setTimeout(() => setSuccess(false), 3000)
    } catch (err) {
      console.error("Error al eliminar tipo:", err)
      const errorMessage = err?.response?.data?.message || err?.message || "No se pudo eliminar el tipo"
      setError(errorMessage)
    } finally {
      setLoading(false)
    }
  }


  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 3 } }}>
      {/* Encabezado principal */}
      <Card
        elevation={3}
        sx={{
          mb: 3,
          borderRadius: 3,
          backgroundColor: "#5b5b5f",
          "&:hover": {
            backgroundColor: alpha("#5b5b5f", 0.9),
          },
          color: "white",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <PaymentIcon
              sx={{
                fontSize: 32,
                color: "rgb(244, 177, 14)",
                mr: 1.5,
              }}
            />
            <Typography variant="h4" component="h1" sx={{ fontWeight: 700, color: "white" }}>
              Gestión de Tipos y Medios de Pago
            </Typography>
          </Box>
          <Typography variant="body1" color="white" sx={{ ml: 6 }}>
            Administre los tipos de medios de pago y sus medios de pago asociados
          </Typography>
        </CardContent>
      </Card>

      {/* Alertas */}
      <Fade in={success}>
        <Alert
          severity="success"
          sx={{
            mb: 2,
            borderRadius: 2,
            boxShadow: 2,
          }}
          onClose={() => setSuccess(false)}
        >
          {successMessage}
        </Alert>
      </Fade>

      {error && (
        <Alert
          severity="error"
          sx={{
            mb: 2,
            borderRadius: 2,
            boxShadow: 2,
          }}
          onClose={() => setError(null)}
        >
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* Sección de Tipo Medio de Pago */}
        <Grid item xs={12} lg={6}>
          <Card
            elevation={2}
            sx={{
              borderRadius: 2,
              height: "fit-content",
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <AccountBalanceWalletIcon
                  sx={{
                    fontSize: 24,
                    color: "rgb(244, 177, 14)",
                    mr: 1.5,
                  }}
                />
                <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                  Crear Tipo de Medio de Pago
                </Typography>
              </Box>

              <Divider sx={{ mb: 3 }} />

              <form onSubmit={handleTipoMedioDePagoSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Descripción del Tipo"
                      variant="outlined"
                      fullWidth
                      value={descripcionMedioPago}
                      onChange={(e) => setDescripcionMedioPago(e.target.value)}
                      disabled={loading}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PaymentIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={verEnCajaMedioPago}
                            onChange={(e) => setVerEnCajaMedioPago(e.target.checked)}
                            color="primary"
                            disabled={loading}
                          />
                        }
                        label="Ver en Caja"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={verEnTransaccionMedioPago}
                            onChange={(e) => setVerEnTransaccionMedioPago(e.target.checked)}
                            color="primary"
                            disabled={loading}
                          />
                        }
                        label="Ver en Transacción"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={esMultiMonedaMedioPago}
                            onChange={(e) => setEsMultiMonedaMedioPago(e.target.checked)}
                            color="primary"
                            disabled={loading}
                          />
                        }
                        label="Es Multi-moneda"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={esPagoDiferidoMedioPago}
                            onChange={(e) => setEsPagoDiferidoMedioPago(e.target.checked)}
                            color="primary"
                            disabled={loading}
                          />
                        }
                        label="Es Pago Diferido"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={userSelect}
                            onChange={(e) => setUserSelect(e.target.checked)}
                            color="primary"
                            disabled={loading}
                          />
                        }
                        label="Selección por Usuario"
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={loading}
                      startIcon={<AddCircleOutlineIcon />}
                      fullWidth
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        boxShadow: 2,
                        py: 1.5,
                        backgroundColor: "#5b5b5f",
                        "&:hover": {
                          backgroundColor: alpha("#5b5b5f", 0.9),
                        },
                      }}
                    >
                      Agregar Tipo de Medio de Pago
                    </Button>
                  </Grid>
                </Grid>
              </form>

              {/* Lista de tipos existentes */}
              <Box sx={{ mt: 3 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: "#2d3748" }}>
                  Tipos Existentes ({tipoMedioDePago.length})
                </Typography>
                <Box sx={{ maxHeight: 300, overflow: "auto" }}>
                  <List dense>
                    {tipoMedioDePago.map((tipo) => (
                      <ListItem
                        key={tipo.id}
                        sx={{
                          borderRadius: 1,
                          mb: 0.5,
                          backgroundColor: "#f8f9fa",
                          "&:hover": {
                            backgroundColor: "#E3EAFD",
                          },
                        }}
                      >
                        <ListItemIcon>
                          <AccountBalanceWalletIcon sx={{ color: "rgb(244, 177, 14)", fontSize: 20 }} />
                        </ListItemIcon>
                        <Box sx={{ flexGrow: 1, mr: 2 }}>
                          <ListItemText
                            primary={tipo.descripcion}
                            primaryTypographyProps={{
                              fontWeight: 500,
                              fontSize: "0.95rem",
                            }}
                          />
                        </Box>
                        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mr: 1 }}>
                          {tipo.verEnCaja && (
                            <Chip label="Caja" size="small" sx={{ fontSize: "0.7rem", height: 20 }} />
                          )}
                          {tipo.verEnTransaccion && (
                            <Chip label="Trans." size="small" sx={{ fontSize: "0.7rem", height: 20 }} />
                          )}
                          {tipo.esMultiMoneda && (
                            <Chip label="Multi" size="small" sx={{ fontSize: "0.7rem", height: 20 }} />
                          )}
                        </Box>
                        <Chip
                          label={`ID: ${tipo.id}`}
                          size="small"
                          sx={{
                            backgroundColor: alpha("#5b5b5f", 0.1),
                            color: "#5b5b5f",
                            fontSize: "0.75rem",
                          }}
                        />
                        <Box sx={{ display: "flex", alignItems: "center", ml: 1, gap: 0.5 }}>
                          <Tooltip title="Editar tipo">
                            <span>
                              <IconButton
                                size="small"
                                onClick={() => handleTipoEditStart(tipo)}
                                disabled={loading}
                                sx={{
                                  color: "rgb(244, 177, 14)",
                                  bgcolor: alpha("rgb(244, 177, 14)", 0.1),
                                  "&:hover": {
                                    bgcolor: alpha("rgb(244, 177, 14)", 0.2),
                                  },
                                }}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                          <Tooltip title="Eliminar tipo">
                            <span>
                              <IconButton
                                size="small"
                                onClick={() => handleTipoDelete(tipo.id)}
                                disabled={loading}
                                sx={{
                                  color: "#d32f2f",
                                  bgcolor: alpha("#d32f2f", 0.1),
                                  "&:hover": {
                                    bgcolor: alpha("#d32f2f", 0.2),
                                  },
                                }}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>

        {/* Sección de Medio de Pago */}
        <Grid item xs={12} lg={6}>
          <Card
            elevation={2}
            sx={{
              borderRadius: 2,
              height: "fit-content",
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <CreditCardIcon
                  sx={{
                    fontSize: 24,
                    color: "rgb(244, 177, 14)",
                    mr: 1.5,
                  }}
                />
                <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                  Crear Medio de Pago
                </Typography>
              </Box>

              <Divider sx={{ mb: 3 }} />

              <form onSubmit={handleMedioDePagoSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl fullWidth variant="outlined">
                      <InputLabel id="tipo-medio-pago-label">Tipo de Medio de Pago</InputLabel>
                      <Select
                        labelId="tipo-medio-pago-label"
                        value={selectedTipoMedioDePago}
                        onChange={(e) => setSelectedTipoMedioDePago(e.target.value)}
                        label="Tipo de Medio de Pago"
                        disabled={loading}
                        sx={{
                          borderRadius: 2,
                        }}
                      >
                        <MenuItem value="" disabled>
                          Seleccione un tipo
                        </MenuItem>
                        {tipoMedioDePago.map((tipo) => (
                          <MenuItem key={tipo.id} value={tipo.id}>
                            {tipo.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      label="Descripción del Medio de Pago"
                      variant="outlined"
                      fullWidth
                      value={nuevoMedioDePago}
                      onChange={(e) => setNuevoMedioDePago(e.target.value)}
                      disabled={loading}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CreditCardIcon color="action" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      type="submit"
                      disabled={loading}
                      startIcon={<AddCircleOutlineIcon />}
                      fullWidth
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        boxShadow: 2,
                        py: 1.5,
                        backgroundColor: "#5b5b5f",
                        "&:hover": {
                          backgroundColor: alpha("#5b5b5f", 0.9),
                        },
                      }}
                    >
                      Agregar Medio de Pago
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tablas */}
      <Card
        elevation={2}
        sx={{
          mt: 3,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
              <CreditCardIcon
                sx={{
                  fontSize: 24,
                  color: "rgb(244, 177, 14)",
                  mr: 1.5,
                }}
              />
              <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                Medios de Pago
              </Typography>
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={fetchData}
              disabled={loading}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                minWidth: 120,
                borderColor: "rgb(244, 177, 14)",
                color: "rgb(244, 177, 14)",
                "&:hover": {
                  borderColor: alpha("rgb(244, 177, 14)", 0.8),
                  backgroundColor: alpha("rgb(244, 177, 14)", 0.05),
                },
              }}
            >
              Actualizar
            </Button>
          </Box>

          <Divider sx={{ mb: 2 }} />

          <TablaMedioDePagoComponent />
        </CardContent>
      </Card>

      {/* Modal de Edición de Tipo */}
      <Dialog
        open={editTipoModalOpen}
        onClose={handleTipoEditCancel}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: 24,
          }
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#5b5b5f",
            color: "#ffffff",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <EditIcon />
          Editar Tipo de Medio de Pago
        </DialogTitle>
        <DialogContent sx={{ mt: 3 }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Descripción"
              variant="outlined"
              fullWidth
              value={editTipoDescripcion}
              onChange={(e) => setEditTipoDescripcion(e.target.value)}
              disabled={loading}
              autoFocus
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PaymentIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
            
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={editTipoVerEnCaja}
                    onChange={(e) => setEditTipoVerEnCaja(e.target.checked)}
                    color="primary"
                    disabled={loading}
                  />
                }
                label="Ver en Caja"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={editTipoVerEnTransaccion}
                    onChange={(e) => setEditTipoVerEnTransaccion(e.target.checked)}
                    color="primary"
                    disabled={loading}
                  />
                }
                label="Ver en Transacción"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={editTipoEsMultiMoneda}
                    onChange={(e) => setEditTipoEsMultiMoneda(e.target.checked)}
                    color="primary"
                    disabled={loading}
                  />
                }
                label="Es Multi-moneda"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={editTipoEsPagoDiferido}
                    onChange={(e) => setEditTipoEsPagoDiferido(e.target.checked)}
                    color="primary"
                    disabled={loading}
                  />
                }
                label="Es Pago Diferido"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={editTipoUserSelect}
                    onChange={(e) => setEditTipoUserSelect(e.target.checked)}
                    color="primary"
                    disabled={loading}
                  />
                }
                label="Selección por Usuario"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={editTipoAfectaCuentaCorriente}
                    onChange={(e) => setEditTipoAfectaCuentaCorriente(e.target.checked)}
                    color="primary"
                    disabled={loading}
                  />
                }
                label="Afecta Cuenta Corriente"
              />
            </Box>

            {error && (
              <Alert severity="error" onClose={() => setError(null)}>
                {error}
              </Alert>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, gap: 1 }}>
          <Button
            onClick={handleTipoEditCancel}
            disabled={loading}
            startIcon={<CloseIcon />}
            sx={{
              color: "#6b6b6b",
              "&:hover": {
                backgroundColor: alpha("#6b6b6b", 0.1),
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleTipoEditSave}
            disabled={loading}
            variant="contained"
            startIcon={<SaveIcon />}
            sx={{
              backgroundColor: "#5b5b5f",
              "&:hover": {
                backgroundColor: alpha("#5b5b5f", 0.9),
              },
            }}
          >
            Guardar Cambios
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default GestionMedioPago
